<!-- <div class="flex gap-4 w-full h-full pb-6">


  <div class="flex flex-col gap-2 w-full">
    <div class="flex-col flex gap-4 pb-2 w-full">
      <span class="text-[24px]">Analytics</span>
    </div>
    <div class="flex gap-6 h-full w-full">
      <div class="w-72 overflow-clip bg-white h-full rounded-t-xl">
        <div class="flex flex-col">
          <button
            *ngFor="let item of subMenuItems"
            [routerLink]="'/home/analytics/' + item.route"
            routerLinkActive="bg-primary text-white"
            class="p-5 items-center flex justify-between"
          >
            <div class="flex items-center gap-2">
              <span>{{ item.name }}</span>
            </div>
            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="inherit"
              class="stroke-white fill-none"
              routerLinkActive="stroke-white"
            >
              <path
                d="M6.79083 13.0302L10.8597 8.9613L6.79083 4.8924"
                stroke="inherit"
                stroke-width="1.3563"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="w-full overflow-y-auto h-full pb-20">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div> -->

<div class="bg-primary rounded-xl mb-6 p-2">
  <div class="flex gap-12">
    <button
      *ngFor="let item of subMenuItems"
      [routerLink]="'/home/analytics/' + item.route"
      routerLinkActive="bg-white rounded-lg"
      class="p-2 items-center flex justify-between text-white"
    >
      <div class="flex items-center gap-5">
        <span
          [class.text-[#0058e9]]="
            router.isActive('/home/analytics/' + item.route, true)
          "
          >{{ item.name }}</span
        >
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path [attr.stroke]="router.isActive('/home/analytics/' + item.route, true) ? '#0058e9' : 'white'" stroke-width="1.29537" stroke-linecap="round" stroke-linejoin="round" d="M4.6145 6.05859L8.50061 9.9447L12.3867 6.05859"/>
          <path [attr.stroke]="router.isActive('/home/analytics/' + item.route, true) ? '#0058e9' : 'white'" stroke-opacity="0.2" stroke-width="1.29537" stroke-linecap="round" stroke-linejoin="round" d="M4.6145 6.05859L8.50061 9.9447L12.3867 6.05859"/>
        </svg> -->
      </div>
    </button>
  </div>
</div>

<router-outlet></router-outlet>
